import { actions } from '../../utils/constants';

export const asyncCreateQuestion = ({ question, options, hasNewQuestion }) => ({
    type: actions.ASYNC_CREATE_QUESTION,
    payload: { question, options, hasNewQuestion },
});

export const changeSuccessAddQuestion = value => ({
    type: actions.CHANGE_SUCCESS_ADD_QUESTION,
    payload: value,
});



// WEBPACK FOOTER //
// ./src/components/add-question/add-question.actions.js